import React, { Dispatch, SetStateAction } from 'react'

import { Container, MessageError, LoadingContainer, SkeletonItem, ContainerSkeletonButton } from './styles'
import { EchocardiogramTestDetailsContent } from './content'
import { HealthProcedureDetails } from '../healthProcedureDetails'
import { ModalHeaderSkeleton } from '../ModalComponents/ModalHeader/Skeleton'
import { IHealthProcedures } from '~/interfaces'
import { useFetchEchocardiogramTest } from '~/hooks'
import { DataNotFound } from '~/components/shared'

interface Props {
  healthProcedure: IHealthProcedures
  showModal: boolean
  setShowModal: Dispatch<SetStateAction<boolean>>
}

export const EchocardiogramTestDetails = ({ healthProcedure, showModal, setShowModal }: Props): JSX.Element => {
  const {
    data: echocardiogramTest,
    isLoading,
    error
  } = useFetchEchocardiogramTest({
    pathParams: { testId: healthProcedure.id }
  })

  const renderContent = () => {
    if (error)
      return (
        <MessageError>
          <DataNotFound text={error.message} />
        </MessageError>
      )
    if (isLoading) {
      return (
        <LoadingContainer>
          <ModalHeaderSkeleton />
          <ContainerSkeletonButton>
            <SkeletonItem width={'207px'} height={'24px'} />
          </ContainerSkeletonButton>
        </LoadingContainer>
      )
    }
    if (echocardiogramTest) return <EchocardiogramTestDetailsContent echocardiogramTestDetails={echocardiogramTest} />
  }

  return (
    <HealthProcedureDetails showModal={showModal} setShowModal={setShowModal} viewType="SideModal">
      <Container>{renderContent()}</Container>
    </HealthProcedureDetails>
  )
}
